import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query StripeInvoicePage($stripeInvoiceId: ID!) {
    stripeInvoicePage(stripeInvoiceId: $stripeInvoiceId) {
      url
    }
  }
`;

export function queryStripeInvoicePage(stripeInvoiceId) {
  return executeGqlQuery({
    query: QUERY,
    variables: {
      stripeInvoiceId,
    },
  }).then(({ data }) => getSingleProp(data));
}
